import(/* webpackMode: "eager", webpackExports: ["Navbar"] */ "/app/apps/web/src/components/landing/Navbar.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["TrendsBrowser"] */ "/app/apps/web/src/components/landing/TrendsBrowser.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/app/node_modules/.pnpm/next@15.5.9_@opentelemetry+api@1.9.0_react-dom@19.2.3_react@19.2.3__react@19.2.3/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/.pnpm/next@15.5.9_@opentelemetry+api@1.9.0_react-dom@19.2.3_react@19.2.3__react@19.2.3/node_modules/next/dist/client/image-component.js");
